module.exports = __webpack_public_path__ + "static/logo_free_your_inbox_rvb-5f7af6cd59598974ecf0ecf848169bda.svg";